module.exports = __webpack_public_path__ + "img/trash-empty.f6fac067.png";